import {put,takeLatest,call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    ADD_VENUE,
    ADD_VENUE_SUCCESS,
    ADD_VENUE_ERROR
}
    from "../../actions/venue"

function* addVenueSaga(action) {
    try {
        const data=yield call(venueService.AddVenue,action.payload)
        yield put({
            type: ADD_VENUE_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: ADD_VENUE_ERROR,error: error.data
        })
    }
}


export function* addVenueSagaWatcher() {
    yield takeLatest(ADD_VENUE,addVenueSaga)
}